import { IExtendedSearchData } from "src/api/server/extended-search.types";
import { ISearchStore } from "../store/search-store";
import { mapBrokerIdsToQuery } from "./map-broker-ids";
import { mapIsAtInvestableToQuery, mapIsChInvestableToQuery, mapIsInvestableToQuery } from "./map-is-investable";
import { mapKeyFiguresToQuery } from "./map-key-figures";
import { mapLeverageProductsIndicationToQuery } from "./map-leverage-products-indication";
import { mapSearchTermToQuery } from "./map-search-term";
import { mapSelectedRankingToQuery } from "./map-selected-ranking";
import { mapSortDirectionToQuery } from "./map-sort-direction";
import { mapTagsToQuery } from "./map-tags";
import { mapViewToQuery } from "./map-view";

export const mapStateToQueryString = (
    state: ISearchStore,
    extendedSearchData: IExtendedSearchData,
    country: string,
    caller: string | null
): string => {
    // We map to old names of properties to maintain backwards compatibility
    const {
        tags,
        isInvestable,
        sortDirection,
        query,
        leverageProductsIndication,
        isAtInvestable,
        isChInvestable,
        selectedRanking,
        keyFigures,
        brokersIds,
        view,
    } = state;

    // Next.js by default encodes URI and converts commas to %2C
    // Only setting query string manually allows us to introduce comma as separator
    // and maintaining backwards compatibility.
    const queryString = [
        mapTagsToQuery(tags),
        mapIsInvestableToQuery(isInvestable),
        mapIsAtInvestableToQuery(isAtInvestable, country),
        mapIsChInvestableToQuery(isChInvestable, country),
        mapSortDirectionToQuery(sortDirection),
        mapSearchTermToQuery(query),
        mapLeverageProductsIndicationToQuery(leverageProductsIndication),
        mapSelectedRankingToQuery(selectedRanking, extendedSearchData.rankingsData),
        mapKeyFiguresToQuery(
            keyFigures,
            extendedSearchData.keyFiguresData.keyFiguresGroups.flatMap(keyFigureGroup => keyFigureGroup.keyFigures)
        ),
        mapBrokerIdsToQuery(brokersIds),
        mapViewToQuery(view),
        caller ? `caller=${caller}` : "",
    ]
        .filter(queryStringPart => queryStringPart.length > 0)
        .join("&");

    return queryString;
};
